module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/160-northern-marianas-islands-3a8653969435db39840b7f99cd7be379.svg";